// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__LAObk","topBottomGutter":"Layout_topBottomGutter__hPx1T"};